module.exports = __webpack_public_path__ + "static/media/router.42324418.png";


//////////////////
// WEBPACK FOOTER
// ./src/semantic/dist/themes/fibrestream/assets/images/router.png
// module id = 989
// module chunks = 0